import React  from 'react'

import ColorComponentProto from './color-proto'

export default function renderColorInView(id, props) {
    return <ColorComponentProto renderMode="view" id={id} {...props} />
}